import { Modal } from "react-bootstrap";
import { OverrideDate } from "../models/ProductionSiteCalendarModel";
import { Field, Form, Formik } from "formik";
import { Input } from "../../../_metronic/_partials/controls";
import DeleteIcon from "../../svg/DeleteIcon";
import ActiveIconWithCopy from "../../svg/ActiveIconWithCopy";
import * as Yup from "yup";

type Props = {
    override: OverrideDate
    onCancel: () => void
    onDelete: () => void
    onSave: (override: OverrideDate) => void
}

const OverrideDateEditModal = (props: Props) => {
    const { onCancel, onDelete, onSave } = props;
    const editableOverride = { ...props.override } as OverrideDate;

    const overrideValidation = Yup.object().shape({
        label: Yup.string()
            .required("Please enter a date label")
    })

    return (
        <Modal size="lg" show={true} onEscapeKeyDown={onCancel}>
            <Modal.Header>
                <Modal.Title id="override-date-edit-modal">
                    Edit Production Date Override For {props.override.date}
                </Modal.Title>
            </Modal.Header>
            <Formik
                initialValues={editableOverride}
                validationSchema={overrideValidation}
                validateOnChange={true}
                validateOnBlur={false}
                onSubmit={(override, formikBag) => {
                    formikBag.setSubmitting(false);
                    onSave(override);
                }}>
                {formikProps => (
                    <Form className="form">
                        <Modal.Body>
                            <div className="form-row">
                                <button type="button"
                                    onClick={() => {
                                        formikProps.setFieldValue("isProductionDate", !formikProps.values.isProductionDate)
                                        formikProps.setFieldTouched("isProductionDate", true)
                                    }}
                                    className='table-action-icons-container-button-small col-2'
                                >
                                    <ActiveIconWithCopy
                                        active={formikProps.values.isProductionDate}
                                        copy={formikProps.values.isProductionDate ? 'Producing' : 'Closed'}
                                        customStyle='table-action-icons-children-small'
                                        color="#1BC5BD" //same as bg-success in FullCalendar
                                    />
                                </button>
                                <div className="form-group col">
                                    <label htmlFor="override-date-edit-modal-label">Label</label>
                                    <Field
                                        component={Input}
                                        id="override-date-edit-modal-label"
                                        name="label"
                                        placeholder='override label'
                                        type="string"
                                    />
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="d-flex justify-content-between width-set-100">
                                <button
                                    type="button"
                                    className="text-primary border-0 bg-transparent"
                                    onClick={onDelete}>
                                    <div className="d-flex text-danger mt-3">
                                        <u className="mr-1 mt-2">Delete Override</u>
                                        <DeleteIcon color="#F64E60" />
                                    </div>
                                </button>
                                <div className="d-flex justify-content-end">
                                    <button
                                        type="button"
                                        onClick={onCancel}
                                        className='btn btn-outline-theme border-2 fw-bold mr-5 mb-sm-5 mb-md-0'>
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className='btn btn-primary-theme border-2 fw-bold mr-5 mb-sm-5 mb-md-0'>
                                        Save
                                    </button>
                                </div>
                            </div>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik >
        </Modal >
    );
}

export default OverrideDateEditModal;